import autoload from "./autoload";
import auth from "./mixins/auth";
import cart from "./mixins/cart";
import initDom from "./mixins/init_dom";
import SeriesCard from "./shop/SeriesCard";

autoload();

window.app = new Vue({
  el: "#vue-shop",

  components: {
    SeriesCard,
  },

  mixins: [auth, cart, initDom],

  data() {
    return {
      fSeriesData: {
        title: "F Series",
        cure: "Oven",
        keyFeatures: [
          "PFAS-Free",
          "Developed for manufacturing and high-volume production",
          "Fast Curing – cures in 15 minutes at 250°F",
          "Perfect for tight tolerance applications",
          "Unmatched corrosion, chemical and durability performance",
          "Innovative ceramic-polymer technology for flexibility and superior performance",
          "Common Uses: Automotive, firearms, aerospace, knives, eye wear, consumer electronics, wearables, and saltwater applications",
        ],
      },
      eSeriesData: {
        title: "E Series",
        cure: "Oven",
        keyFeatures: [
          "Highest performing thin film ceramic coatings on the market",
          "Unmatched abrasion, corrosion and chemical resistance",
          "Coefficient of friction, rivaling Teflon®",
          "Perfect for tight tolerance applications and typically eliminates the need for masking.",
          "Common Uses: Automotive, firearms, aerospace, knives, eye wear, consumer electronics, wearables, industrial valves, oil & gas, salt water applications and much more",
        ],
      },
      hSeriesData: {
        title: "H Series",
        cure: "Oven",
        keyFeatures: [
          "The unrivaled leader in thin film protective coatings in over 100 colors.",
          "Perfect for tight tolerance applications and typically eliminates the need for masking.",
          "Unmatched corrosion, chemical and durability performance",
          "Unique ceramic-polymer technology that imparts both flexibility and excellent physical performance",
          "Common Uses: Automotive, firearms, aerospace, knives, eye wear, consumer electronics, wearables, salt water applications and much more",
        ],
      },
      cSeriesData: {
        title: "C Series",
        cure: "Air",
        keyFeatures: [
          "Formulated to withstand temperatures up to 1800°F (See individual product descriptions for specific temperature rating)",
          "Single component, ready to spray",
          "Direct to substrate - no primer required",
          "Over 50 colors available",
          "Excellent UV Stability",
          "Great option for large or small parts that cannot be oven cured",
          "Extremely high chemical resistance",
          "Uses: Automotive, wheels, exhaust systems, firearms, architectural, lighting, hardware, optics and much more",
        ],
      },
      performanceClearsData: {
        title: "Performance Clears",
        cure: "Air & Oven",
        keyFeatures: [
          "Ceramic clear coatings with unmatched performance",
          "Unrivaled durability, hardness and scratch resistance",
          "Excellent chemical resistance and flexibility",
          "Excellent UV stability (See tech data sheet for specific UV rating)",
          "Single component, ready to spray",
          "Uses: Metals (including all common alloys of aluminum), Composites, Plastics, PVD, Hydrographics and more",
        ],
      },
      vSeriesData: {
        title: "V Series",
        cure: "Oven",
        keyFeatures: [
          "Best performing ultra-high temperature coating on the market",
          "Up to 1800°F High Temp",
          "Industry leading heat-cycled corrosion resistance",
          "Withstands thermal shock without degrading or losing color",
          "100% UV Stable",
          "Extremely high chemical resistance",
          "Uses:  Exhaust systems, headers, turbos, manifolds, furnaces, industrial and much more",
        ],
      },
      specialtyCoatingsData: {
        title: "Specialty Coatings",
        cure: "Air & Oven",
        keyFeatures: [
          "Cerakote coatings with specific performance attributes",
          "NiR signature management",
          "Dielectric",
          "High thermal emissivity",
          "Low thermal emissivity",
          "Non-fluorescing",
          "Low coefficient of friction",
          "Piston coating",
          "Polished ceramic",
          "Cerakote Super Grip®",
          "Cerakote Auto Care Products",
        ],
      },
    };
  },
});
